// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__i9hhB","modalFooterButton":"ModalNotes_modalFooterButton__LkL2w"};